import jpeg from './jpegIcon';
import png from './pngIcon';
import pdf from './pdfIcon';
import document from './document';

export default { pdf, png, jpeg, document };
